import { registerCodeHighlighting } from '@lexical/code';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

export const CodeHighlightPlugin = () => {
  const [editor] = useLexicalComposerContext();

  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect intentionally performs a side effect after render; revisit before adding logic.
  useEffect(() => {
    return registerCodeHighlighting(editor);
  }, [editor]);

  return null;
};
